import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "http://localhost:8001";
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
});

// If a dev token was stored during local login, apply it to axios default headers
try {
  const devToken = localStorage.getItem("auth_token");
  if (devToken) {
    api.defaults.headers.common["Authorization"] = `Bearer ${devToken}`;
  }
} catch (e) {
  // ignore (server-side rendering / no localStorage)
}

export const auth = {
  me: () => api.get("/auth/me").then((r) => r.data),
  session: (session_id) => api.post("/auth/session", { session_id }).then((r) => r.data),
  register: (data) => api.post("/auth/register", data).then((r) => r.data),
  login: (data) => api.post("/auth/login", data).then((r) => r.data),
  devLogin: () => api.post("/auth/dev-login").then((r) => r.data),
  updateMe: (data) => api.patch("/auth/me", data).then((r) => r.data),
  logout: () => api.post("/auth/logout").then((r) => r.data),
};

export const projects = {
  list: () => api.get("/projects").then((r) => r.data),
  create: (data) => api.post("/projects", data).then((r) => r.data),
  get: (id) => api.get(`/projects/${id}`).then((r) => r.data),
  update: (id, data) => api.patch(`/projects/${id}`, data).then((r) => r.data),
  remove: (id) => api.delete(`/projects/${id}`).then((r) => r.data),
  addSprite: (id, data) => api.post(`/projects/${id}/sprites`, data).then((r) => r.data),
  removeSprite: (id, sid) => api.delete(`/projects/${id}/sprites/${sid}`).then((r) => r.data),
  share: (id, is_public) => api.post(`/projects/${id}/share`, { is_public }).then((r) => r.data),
  export: (id, engine) => api.get(`/projects/${id}/export?engine=${engine}`).then((r) => r.data),
};

export const publicApi = {
  get: (slug) => api.get(`/public/projects/${slug}`).then((r) => r.data),
  remix: (slug) => api.post(`/projects/${slug}/remix`).then((r) => r.data),
};

export const ai = {
  ideas: (data) => api.post("/ai/ideas", data).then((r) => r.data),
  sprite: (data) => api.post("/ai/sprite", data, { timeout: 90000 }).then((r) => r.data),
};

export const audioApi = {
  search: (q, kind) => api.get("/audio/search", { params: { q, kind } }).then((r) => r.data),
  fetch: (url, name) => api.post("/audio/fetch", { url, name }).then((r) => r.data),
};

export const spriteApi = {
  search: (params) => api.get("/sprites/search", { params }).then((r) => r.data),
  fetch: (url, name) => api.post("/sprites/fetch", { url, name }).then((r) => r.data),
};
